import React from 'react';
import {quotationTabs} from '../constants';
import './quotations-tab-pane.styles.scss';
import clsx from 'clsx';
import {useTranslation} from 'react-i18next';
import {NavLink, useParams} from 'react-router-dom';
import {Nav, NavItem} from 'reactstrap';

const QuotationsTabPane = () => {
  const {t} = useTranslation();

  const {id} = useParams();

  const prefix = `/dashboard/quotations/${id}`;

  const tabs = quotationTabs;
  return (
    <Nav className="nav-tabs-custom card-header-tabs border-top mt-2 tab-pane">
      {tabs.map(x => (
        <NavItem key={x.to}>
          <NavLink
            className={active =>
              clsx({active: active.isActive}, 'px-3 nav-link')
            }
            to={`${prefix}/${x.to}`}
          >
            {t(...x.title())}
          </NavLink>
        </NavItem>
      ))}
    </Nav>
  );
};

export default QuotationsTabPane;
